{
  "title": "Train with us on the Silver Coast",
  "date": "2026-06-20",
  "category": "Dojo",
  "excerpt": "Our Thalwil location offers focused classes for kids, adults and women in a family-friendly setting.",
  "body": "The Silver Coast dojo continues the same teaching philosophy that shaped our Zurich community: structured classes, personal attention and a welcoming atmosphere. Browse the Thalwil schedule and contact us to find the right first class.",
  "image": "/images/silver-main.jpeg",
  "featured": false
}
